/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * Confidential and proprietary. Author: Alexander Orlov.
 *
 * Book a specific car. Loads the listing and renders the shared blue BookingView.
 */

import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Car } from '../types';
import api from '../services/api';
import BookingView from '../components/booking/BookingView';

export default function CarBookingPage() {
  const { t } = useTranslation();
  const { carId } = useParams<{ carId: string }>();
  const [car, setCar] = useState<Car | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!carId) return;
    setLoading(true);
    api.getCar(carId).then(setCar).catch(() => setCar(null)).finally(() => setLoading(false));
  }, [carId]);

  if (loading)
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center text-gray-500">{t('detail.loading')}</div>
    );
  if (!car)
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center text-center px-4">
        <p className="text-gray-700">{t('detail.notFound')}</p>
        <Link to="/" className="mt-3 underline text-blue-600">{t('detail.backToSearch')}</Link>
      </div>
    );

  return <BookingView car={car} />;
}
